import { render, staticRenderFns } from "./spareGetAdd.vue?vue&type=template&id=3f056610&scoped=true"
import script from "./spareGetAdd.vue?vue&type=script&lang=js"
export * from "./spareGetAdd.vue?vue&type=script&lang=js"
import style0 from "./spareGetAdd.vue?vue&type=style&index=0&id=3f056610&prod&scoped=true&lang=scss"
import style1 from "./spareGetAdd.vue?vue&type=style&index=1&id=3f056610&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f056610",
  null
  
)

export default component.exports